"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ic_chat(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 192 192"
  }, props), /*#__PURE__*/React.createElement("title", null, "chat-hi"), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "08fdf79a-6d19-4e5f-a9f6-0b792c46d4ab",
    "data-name": "chat-hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "eef2fdf4-02e8-450d-984c-6dc1e00de9db",
    "data-name": "Apps_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "b2fdfd2a-8953-4173-a506-b4f52092c006",
    "data-name": "Bill_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "149ea1c2-e537-4c03-a738-ba850ff6c1ce",
    "data-name": "Report_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "7b09c60c-e18b-4f8c-bdbe-4cfbeb079507",
    "data-name": "vodafone_store_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "de998a26-195f-43df-9708-5ee42b3ea358",
    "data-name": "Broadband_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "05309076-ab8a-4fa2-8bde-65c2a33c352a",
    "data-name": "Business_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "408b36bd-72d8-4ebd-be25-e56616fcef85",
    "data-name": "Calendar_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "6ed2044c-3bf1-49d1-93ab-75e1146e4b44",
    "data-name": "Camera_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "69c00fff-79d2-4582-80cc-79e884bf1fbc",
    "data-name": "Data_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "cdde0867-e0f5-4452-b5b8-84876c73436b",
    "data-name": "Desktop_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "78348fcf-4e66-45d8-888e-ec6e3e933a7e",
    "data-name": "Document_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "8ee31e76-6e65-481d-a639-d156bae3a44a",
    "data-name": "Edit_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "3d342edf-1be5-40b4-845d-5eabe18856f5",
    "data-name": "Enterprise_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "750def13-dd0e-45a3-bbf0-cb8a5b5fe09e",
    "data-name": "Call_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "2465e580-c38a-4f56-987e-ab1845b5066e",
    "data-name": "Location_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "e73e7c52-6807-4298-9587-0c955be59a95",
    "data-name": "Mail_new_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "9e47c884-ddc0-4ae3-8edf-304c4aab75cd",
    "data-name": "Mail_unread_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "329f3cb6-8d2c-4824-852a-9b9f2187afb8",
    "data-name": "Mobile_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "288cde63-cc85-42aa-9b64-4403f1b27d62",
    "data-name": "Network_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "18d7ca11-0f0c-47c4-8b33-0f8af80610cf",
    "data-name": "Reports_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "04c6daac-5ce2-4fa4-95ca-c9dce872d540",
    "data-name": "Roaming_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "37932b25-cdf4-4b7a-aa99-609a3c392db2",
    "data-name": "Security_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "288fd9c6-9722-465a-b938-1077f0dd168e",
    "data-name": "Sim_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "0926e2de-6125-4350-902f-382783bbb4b4",
    "data-name": "Tablet_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "de9888db-d5ed-4b60-bb4d-b0133e68e4ce",
    "data-name": "Text_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "acd98fe2-f488-4b83-8394-6f2844c92598",
    "data-name": "TV_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "7a6fbc0a-ad8f-44a7-a0e8-a83bd85a2c45",
    "data-name": "Warning_ic_hi"
  }, /*#__PURE__*/React.createElement("path", {
    id: "b43dad2d-02e3-4dc8-b43b-00a4aa3ceb86",
    "data-name": "<Pfad>",
    d: "M143.85,73.05s.29-1.49.37-2c1.63-9.86-5-19.26-5-19.26a51.08,51.08,0,0,0-14.65-15.15,67.34,67.34,0,0,0-21.08-9.52,80.3,80.3,0,0,0-25.35-2.41,81.12,81.12,0,0,0-25,5.5,69.14,69.14,0,0,0-20,12,52.74,52.74,0,0,0-13,16.85A41.16,41.16,0,0,0,16,79a39.71,39.71,0,0,0,2.74,12.64,43.84,43.84,0,0,0,6.53,11.19,52.49,52.49,0,0,0,9.75,9.36c3.73,2.77,11.51,6.15,16,8.12-5.87,13.79-19.6,21.92-19.6,21.92a69,69,0,0,0,16.89-.68,66.6,66.6,0,0,0,11.61-3s4.64-1.65,17.95-9l1.71-.94",
    transform: "translate(0 0)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 192,
    height: 192,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "49f225fb-1cdc-4309-a783-4d9d922b4433",
    "data-name": "<Pfad>",
    d: "M145.65,73.57l-2.35-.68A62.52,62.52,0,0,0,123.49,71,63.18,63.18,0,0,0,104,75.32a54,54,0,0,0-15.62,9.45A41.36,41.36,0,0,0,78.18,98,32.4,32.4,0,0,0,75,113.6a31.88,31.88,0,0,0,4.74,15.13,40,40,0,0,0,11.45,11.89,52.45,52.45,0,0,0,16.47,7.47A62.43,62.43,0,0,0,127.46,150l.65-.05a55.63,55.63,0,0,0,7.05,4.09,53.49,53.49,0,0,0,9.28,3.49,51.22,51.22,0,0,0,11.32,1.76,53.53,53.53,0,0,0,13.17-1.09s-13.83-8-14.21-16.31a50.76,50.76,0,0,0,9.09-6.78,42.49,42.49,0,0,0,6.84-8.24,35.39,35.39,0,0,0,4.19-9.35,31.58,31.58,0,0,0-3.6-25.25,38.1,38.1,0,0,0-7-8.34,65.38,65.38,0,0,0-18.6-10.33",
    transform: "translate(0 0)",
    fill: "#e60000"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.06
  }, /*#__PURE__*/React.createElement("path", {
    d: "M78.79,127.1l-.84.46c-13.3,7.32-17.95,9-17.95,9a66.6,66.6,0,0,1-11.61,3,68.46,68.46,0,0,1-14.17.84c-1.66,1.21-2.73,1.84-2.73,1.84a69,69,0,0,0,16.89-.68,66.6,66.6,0,0,0,11.61-3s4.64-1.65,17.95-9l1.71-.94h0Q79.21,127.87,78.79,127.1Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.34,120c.27-.55.52-1.1.77-1.67-4.53-2-12.31-5.35-16-8.12a52.49,52.49,0,0,1-9.75-9.36,43.85,43.85,0,0,1-6.53-11.19A39.71,39.71,0,0,1,16,77c0-.38,0-.77,0-1.15,0,1,0,2.09,0,3.15a39.71,39.71,0,0,0,2.74,12.64,43.85,43.85,0,0,0,6.53,11.19,52.49,52.49,0,0,0,9.75,9.36C38.59,114.82,45.74,118,50.34,120Z",
    transform: "translate(0 0)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.12
  }, /*#__PURE__*/React.createElement("path", {
    d: "M155.76,157.26a51.22,51.22,0,0,1-11.32-1.76,53.49,53.49,0,0,1-9.28-3.49,55.65,55.65,0,0,1-7.05-4.09l-.65.05a62.44,62.44,0,0,1-19.81-1.89,52.46,52.46,0,0,1-16.47-7.47A40.48,40.48,0,0,1,80.49,127.9c-.26-.39-.52-.78-.76-1.17l-.06-.11a31.86,31.86,0,0,1-4.68-15c0-.2,0-.39,0-.59,0,.86,0,1.72,0,2.59a31.64,31.64,0,0,0,3.81,13.49q.41.77.87,1.52l.06.11a40,40,0,0,0,11.45,11.89,52.46,52.46,0,0,0,16.47,7.47A62.44,62.44,0,0,0,127.46,150l.65-.05a55.65,55.65,0,0,0,7.05,4.09,53.49,53.49,0,0,0,9.28,3.49,51.22,51.22,0,0,0,11.32,1.76,53.54,53.54,0,0,0,13.17-1.09s-1-.57-2.42-1.56A53,53,0,0,1,155.76,157.26Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.83,115.5a35.38,35.38,0,0,1-4.19,9.35,42.5,42.5,0,0,1-6.84,8.24,50.76,50.76,0,0,1-9.09,6.78,8.49,8.49,0,0,0,.3,1.81,50.66,50.66,0,0,0,8.79-6.59,42.5,42.5,0,0,0,6.84-8.24,35.38,35.38,0,0,0,4.19-9.35,31.7,31.7,0,0,0,1.15-9.31A31.84,31.84,0,0,1,174.83,115.5Z",
    transform: "translate(0 0)"
  })))))))))))))))))))))))))))))))));
}

var _default = ic_chat;
exports.default = _default;